module.exports = __webpack_public_path__ + "a635ed992a04b0682a1b54e4875cf2ee.svg";